export const Resourcedownload = [
  { label: "Request ID", key: "resourceId" },
  { label: "Resource Title", key: "jobTitle" },
  { label: "Bank Name", key: "bankName" }, // Will be mapped from bankId
  { label: "Branch Name", key: "branchName" }, // Will be mapped from branchId
  { label: "Request Type", key: "requestType" },
  { label: "Requested Date & Time", key: "requestDateAndTime" },
  { label: "Email", key: "email" },
  { label: "Phone Number", key: "phoneNumber" },
  { label: "Department", key: "reqByDepartment" },
  { label: "Resource Description", key: "description" },
  { label: "Assigned User", key: "assignedUserName" },

  // Staff-specific fields
  { label: "Staff Type", key: "staffId" },
  { label: "Required Skill Set", key: "skills" },
  { label: "Employment Type", key: "employmentType" },
  { label: "Experience Level", key: "expLevel" },



  // Asset-specific fields
  { label: "Asset Name", key: "assetName" },
  { label: "Asset Type", key: "assetTypeId" },
  { label: "Asset Category", key: "assetCategoryId" },
  { label: "Quantity Required", key: "quantity" },
  { label: "Non-Functional Units", key: "nonFunctionalUnits" },

];